<template>
  <div class="container mob-bg-white">
    <loading :active.sync="isLoading" :can-cancel="true"></loading>

    <div class="inner bg-white">
      <div class="row mb-15 title-row">
        <div class="col-12">
          <h2 class="mob-log-title">Forgot Password</h2>
        </div>
        <div class="mob-col d-block d-md-none" style="position: relative">
          <div id="nav-open-login" @click="this.showNav"></div>
        </div>
      </div>
      <flash-message class="myCustomClass"></flash-message>
      <div
        class="dur-privacy"
      >Please enter your email address below and we will send you link to reset your password…</div>
      <div class="row log-in col-md-12">
        <div class="col-md-5">
          <div class="card">
            <div class="card-header">Forgot Password</div>
            <div class="card-body">
              <form @submit.prevent="forgot">
                <div class="form-group">
                  <label for="exampleInputEmail1">Email:</label>
                  <input
                    v-model="email"
                    type="email"
                    class="form-control loginemail"
                    placeholder="Email address"
                    autofocus
                    id="exampleInputEmail1"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                    <span v-if="!$v.email.required">Your email is required</span>
                  </div>
                </div>

                <div class="form-group mb-25">
                  <button type="submit" class="btn btn-green float-right">Reset</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="col-spacer"></div>
      </div>
      <div class="row align-items-start mob-login d-block d-md-none">
        <div class="login-wrap">
          <div class="tab-content">
            <div id="login" class="tab-pane fade in show active">
              <form @submit.prevent="forgot">
                <div class="form-group">
                  <label for="exampleInputEmail1">Email:</label>
                  <input
                    v-model="email"
                    type="email"
                    id="exampleInputEmail1"
                    class="form-control login-txt"
                  />
                </div>
                <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                  <span v-if="!$v.email.required">Your email is required</span>
                </div>

                <div class="form-group mb-25">
                  <button type="submit" class="btn btn-success login-btn float-right">Reset</button>
                </div>
              </form>
            </div>
            <div id="signup" class="tab-pane fade">
              <!-- <p>If you have never used our site before please enter your email address below to get started…</p>
                        <form>                             
                              <div class="form-group mb-50">
                                <label for="exampleInputEmail2">Email:</label>
                                <input type="email" class="form-control signup-txt" >
                              </div>
                              
                              <div class="form-group mb-25">
                                <button type="submit" class="btn btn-success signup-btn float-right">Sign Up</button>
                              </div>
              </form>-->
            </div>
          </div>
        </div>
      </div>

      <div class="spacer-y d-none d-md-block"></div>
      <div class="forgot-pw">
        <pageBottom></pageBottom>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
require('vue-flash-message/dist/vue-flash-message.min.css');
import Vuelidate from 'vuelidate';
import VueFlashMessage from 'vue-flash-message';
Vue.use(Vuelidate);
Vue.use(VueFlashMessage);
import Helper from "../../helper.js";
import Users from "@/services/Users";
import Axios from "axios";
import pageBottom from "../components/pageBottom.vue";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "forgot",
  mixins: [Helper],
  components: {
    Loading,
    pageBottom
  },
  data() {
    return {
      isLoading: false,
      email: "",
      error: false,
      submitted: false
    };
  },
  validations: {
    email: { required, email }
  },
  mounted() {
    if (
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) &&
      this.$route.name == "forgot"
    ) {
      $("#nav").hide();
      $("#body").removeClass("mob-bg");
    }
  },
  methods: {
    forgot() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;

      Users.forgot(this.email)
        .then(request => {
          this.isLoading = false;
          if (request.status) {
            this.flash("We have e-mailed your password reset link.", "alert", {
              timeout: 2000
            });
          }
        })
        .catch(error => {
          this.isLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.dur-privacy {
  width: 100%;
  padding: 10px 15px;
  background: #f7f9fe;
  border: 1px solid #cdd3e3;
  border-radius: 7px;
  margin: 0;
  margin-bottom: 24px;
  color: #292929;
  text-align: center;
  line-height: 17px;
  float: left;
}
.log-in {
  justify-content: center;
}
.invalid-feedback {
  display: block !important;
}
@media (max-width: 575px) {
  .title-row {
    margin-top: 20px;
    margin-bottom: 30px !important;
    .col-12 {
      padding-left: 0px;
    }
  }
  #nav-open-login {
    width: 35px;
    height: 35px;
    border: 2px solid #000000;
    border-radius: 50px;
    background-image: url("../images/menu-black.png");
    //bottom: 0px;
    right: -3px;
    position: absolute;
  }
  .log-in {
    display: none;
  }
  .privacy-col {
    padding: 0;
    .y-bg {
      border: 1px solid #eae09b;
      margin-bottom: 0px;
      margin-top: 15px;
      a {
        color: #007bff;
      }
      p {
        font-size: 15px;
      }
      h5 {
        font-size: 18px;
      }
    }
  }
  .mob-bg-white {
    background-color: white;
  }
  .mob-login {
    background-color: white;
    padding: 0px;
    border: 1px solid #8b8b88;
    display: flex !important;
    .login-wrap {
      width: 100%;
    }
    .tab-content {
      min-height: 300px;
      padding: 15px;
    }
    li {
      background: #e6e6e6;
      a {
        font-size: 15px;
        font-weight: bold;
        color: black;
        margin: 0 !important;
        //border: none !important;
        padding: 0.5rem 5px;
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-left: 1px solid #8b8b88 !important;
        border-bottom: 1px solid #8b8b88;
      }
    }
    .no-br a,
    .no-br a.active {
      border-left: 0 !important;
    }
    .nav-tabs {
      border-bottom: none;
      .nav-link.active {
        color: #1c3e7f !important;
        border-bottom: 1px solid #ffffff !important;
      }
    }
    .tab-pane {
      text-align: left;
      p {
        margin-top: 8px;
        text-align: left;
        color: black;
        font-size: 14px;
      }
      .form-group {
        label {
          text-align: left;
          font-weight: 100;
        }
        .login-txt,
        .signup-txt {
          background: #f9f9f9;
          border-radius: 8px;
          border: 1px solid #c6c5c4;
          font-size: 15px;
        }
        .login-btn,
        .signup-btn {
          width: auto;
          min-width: auto;
          padding: 10px 30px;
          font-size: 18px;
          border-radius: 10px;
        }
      }
    }
  }
  .mob-log-title {
    font-size: 20px;
  }
  .tooltip-icon {
    i {
      font-size: 24px;
      position: relative;
      bottom: -3px;
      left: 3px;
    }
  }
}
</style>
